import { render, staticRenderFns } from "./RegisterTab.vue?vue&type=template&id=2f5c29e0"
import script from "./RegisterTab.vue?vue&type=script&lang=js"
export * from "./RegisterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports